import { Dispatch, SetStateAction } from "react";

import { Filter } from "../../types/GlobalInterfaces";
import { View } from "../../types/PageInterfaces";
import { RefreshQueryButton } from "../PageView/PageViewDashboard/RefreshQueryButton";
import WidgetRenderer from "../Widgets/WidgetRenderer";
import AppDrawer from "./AppDrawer";

interface Props {
  open: boolean;
  onClose: () => void;
  section: any;
  theme: string | undefined;
  record: Record<string, any> | undefined;
  view: View;
  pageID: string;
  parentViewID: string | undefined;
  topLevelFilters?: Filter[];
  setSettings: Dispatch<SetStateAction<any>>;
}

// Simple Drawer for Viewing a Widget within a Dashboard
const ViewWidgetDrawer = ({
  open,
  onClose,
  section,
  theme,
  record,
  view,
  pageID,
  parentViewID,
  topLevelFilters,
  setSettings,
}: Props) => {
  return (
    <AppDrawer
      full
      placement="bottom"
      open={open}
      onClose={onClose}
      headerTitle={section?.Name}
      headerOptions={
        <RefreshQueryButton
          section={section}
          recordID={record?._id}
          viewID={view?._id}
        />
      }
      body={
        <WidgetRenderer
          section={section}
          theme={theme}
          record={record}
          view={view}
          pageID={pageID}
          parentViewID={parentViewID}
          topLevelFilters={topLevelFilters}
          setSettings={setSettings}
          updateWidget={null}
          editMode={false}
          deleteWidget={null}
        />
      }
    />
  );
};

export default ViewWidgetDrawer;
